module.exports = __webpack_public_path__ + "img/smiling_calendar.36b9e5dd.svg";